export default class OrderData{

    Note;
    IdCarrello;
    CodiceCliente;
    CodiceDestinazione;

    constructor(note, idCarrello, codiceCliente, codiceDestinazione){
        this.Note = note;
        this.IdCarrello = idCarrello;
        this.CodiceCliente = codiceCliente;
        this.CodiceDestinazione = codiceDestinazione;
    }
}